var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9294 12V0.47998H20.7934C20.9054 0.47998 21.0547 0.485314 21.2414 0.49598C21.4334 0.501314 21.604 0.517314 21.7534 0.543981C22.4414 0.650647 23.004 0.877314 23.4414 1.22398C23.884 1.57065 24.2094 2.00798 24.4174 2.53598C24.6254 3.05865 24.7294 3.64265 24.7294 4.28798C24.7294 4.93331 24.6227 5.51998 24.4094 6.04798C24.2014 6.57065 23.876 7.00531 23.4334 7.35198C22.996 7.69865 22.436 7.92531 21.7534 8.03198C21.604 8.05331 21.4334 8.06931 21.2414 8.07998C21.0494 8.09065 20.9 8.09598 20.7934 8.09598H18.1054V12H15.9294ZM18.1054 6.06398H20.6974C20.8094 6.06398 20.932 6.05865 21.0654 6.04798C21.1987 6.03731 21.3214 6.01598 21.4334 5.98398C21.7267 5.90398 21.9534 5.77065 22.1134 5.58398C22.2734 5.39198 22.3827 5.18131 22.4414 4.95198C22.5054 4.71731 22.5374 4.49598 22.5374 4.28798C22.5374 4.07998 22.5054 3.86131 22.4414 3.63198C22.3827 3.39731 22.2734 3.18665 22.1134 2.99998C21.9534 2.80798 21.7267 2.67198 21.4334 2.59198C21.3214 2.55998 21.1987 2.53865 21.0654 2.52798C20.932 2.51731 20.8094 2.51198 20.6974 2.51198H18.1054V6.06398Z",
    fill: "#0090FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.355 12V0.47998H13.531V12H11.355Z",
    fill: "#0090FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12V11.728L5.472 2.51198H0.48V0.47998H9.28V0.751981L3.84 9.95198H9.12V12H0Z",
    fill: "#0090FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.d0bc8ca35baa82b6eae05f0db5ae17e5.svg";
export { ForwardRef as ReactComponent };